import type { ReactNode } from 'react';
import { XStack, YStack } from 'tamagui';

import MembershipPlanCard from '@/components/MembershipPlanCard';
import PSIcon from '@/components/ui/PSIcon';
import { fontSize } from '@/constants/tokens';
import type { Membership } from '@/src/api/membershipsApi';
import PSText from './ui/PSText';

/**
 * The event page's membership-gated tiers, clubbed on a `$brandDark` band.
 * Children are `TicketTier`s with `surface="dark"`; `plan` comes from
 * [[derivePlanToUpsellInMembersOnlyTicketTierGroup]].
 */
export default function MembersOnlyTicketTierGroup({
  children,
  upsellPlan,
  onSelectPlan,
  upsellPlanHeaderText,
}: {
  children: ReactNode;
  upsellPlan: Membership | null;
  upsellPlanHeaderText?: string;
  onSelectPlan: (plan: Membership) => void;
}) {
  return (
    <YStack alignSelf="stretch" bg="$brandDark" p="$lg" gap="$md">
      <XStack items="center" gap="$sm">
        <PSIcon
          name="lock-closed-outline"
          size={fontSize.base}
          color="$brandSecondary"
        />
        <PSText.Tags color="$brandSecondary">For members only</PSText.Tags>
      </XStack>

      {children}

      {upsellPlan ? (
        <MembershipPlanCard
          plan={upsellPlan}
          headerText={upsellPlanHeaderText}
          ctaLabel={`Explore ${upsellPlan.name}`}
          onPress={() => onSelectPlan(upsellPlan)}
        />
      ) : null}
    </YStack>
  );
}
